import React, { useEffect, useRef, useState } from 'react'
import Routes from './src/routes'
import { NativeBaseProvider, Box, extendTheme } from 'native-base'
import { ThemeProvider } from './ThemeProvider'
import 'primereact/resources/themes/lara-light-blue/theme.css'
import 'primereact/resources/primereact.min.css'
import packageJson from './package.json'
import Loader from './components/Loader'

// import { Head } from 'expo-head';

document.documentElement.setAttribute('lang', 'pt-br')

export default function App() {
  const refLoader = useRef()
  const [abrirLoader, setAbrirLoader] = useState(false)
  const VERSAO_ATUAL = packageJson.version
  const theme = extendTheme({
    config: {
      initialColorMode: 'Light' //Light ou Dark
    }
  })

  useEffect(() => {
    // Salva a versão atual no localStorage
    const versaoSalva = localStorage.getItem('versao_pwa')
    if (versaoSalva && versaoSalva !== VERSAO_ATUAL) {
      // Se mudou a versão, força o reload limpando o cache
      if ('caches' in window) {
        caches.keys().then(function (names) {
          for (let name of names) caches.delete(name)
        })
      }
      localStorage.setItem('versao_pwa', VERSAO_ATUAL)
      setAbrirLoader(true)
      setTimeout(() => {
        window.location.reload()
      }, 5000)
    } else if (!versaoSalva) {
      localStorage.setItem('versao_pwa', VERSAO_ATUAL)
    }
  }, [])

  return (
    <ThemeProvider>
      <NativeBaseProvider theme={theme}>
        {abrirLoader && <Loader texto={'Atualizando...'} ref={refLoader} />}
        <Box flex={1} safeArea display={'flex'}>
          <Routes />
        </Box>
      </NativeBaseProvider>
    </ThemeProvider>
  )
}
